import { Redirect, Route, RouteProps } from "react-router";
import AuthProtectedPageLayout from "components/layout/AuthProtectedPageLayout";
import * as routePath from "shared/constants/RoutePathConstants";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import { checkIfCurrentUserHasAdminAccess } from "shared/utility/AuthUtility";

export type PrivateRouteProps = {
  path: string;
  isUserLoggedIn: boolean;
  authenticationPath?: string;
  isAdminRoute?: boolean;
  adminRouteFailureRedirection?: string;
} & RouteProps;

export default function PrivateRoute({
  path,
  isUserLoggedIn,
  authenticationPath,
  isAdminRoute,
  adminRouteFailureRedirection,
  ...routeProps
}: PrivateRouteProps) {
  const currentUserHasAdminAccess = useSelector((state: RootState) =>
    checkIfCurrentUserHasAdminAccess(state)
  );

  if (isUserLoggedIn) {
    if (isAdminRoute && !currentUserHasAdminAccess) {
      return <Redirect to={{ pathname: adminRouteFailureRedirection }} />;
    }

    return (
      <AuthProtectedPageLayout>
        <Route {...routeProps} />
      </AuthProtectedPageLayout>
    );
  } else {
    return <Redirect to={{ pathname: authenticationPath }} />;
  }
}

PrivateRoute.defaultProps = {
  authenticationPath: routePath.SIGN_IN,
  adminRouteFailureRedirection: routePath.DASHBOARD,
};
